import React, { useEffect, useRef, useState } from "react";
import "../style/ContractComplete.css";
import { useParams } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../config/config";
import { useReactToPrint } from "react-to-print";
import FinancialRelease from "../components/FinancialRelease";

function ContractComplete({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const { contract_id } = useParams();
  const [contractData, setContractData] = useState();

  useEffect(() => {
    try {
      axios
        .get(apiKey + "/get-complete-contract/" + contract_id, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setContractData(res.data.result[0]);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (err) {
      console.error(err);
    }
  }, [contract_id, token]);
  return (
    <div>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>{lang.Customer_Management || "Customer Management"}</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  className="sidebaricon"
                  xmlns="http://www.w3.org/2000/svg"
                  height="13"
                  width="15"
                  viewBox="0 0 576 512"
                >
                  <path d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z" />
                </svg>
              </li>
              <li className="breadcrumb-item">
                {lang.General_Management || "General Management"}
              </li>
              <li className="breadcrumb-item active">
                {lang.Valid_Contract || "Valid Contract"}
              </li>
              <li className="breadcrumb-item active">
                {lang.complete_contract || "Complete Contract"}
              </li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="row">
                  <div className="col-9"></div>
                  <div className="col-3">
                    <div></div>
                    <div to="/add-customer">
                      <button
                        type="button"
                        onClick={handlePrint}
                        className="btn btn-primary"
                      >
                        {lang.save_contract || "Save Contract"}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="row pt-3">
                  <div className="rr col-9">{lang.contract || "Contract"}</div>
                </div>
                <div className="card-body">
                  <div classNames="d-flex mt-3 mb-3">
                    <div
                      className="w-100"
                      id="contract-form"
                      style={{ paddingBottom: "16rem", overflowX: "auto" }}
                      ref={componentRef}
                    >
                      {/* <ContractViewer htmlContent={contractComplete} /> */}
                      {contractData && (
                        <FinancialRelease contractData={contractData} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default ContractComplete;
